var map = {
	"./betPlace.mp3": 121,
	"./card-big.mp3": 643,
	"./card-small.mp3": 122,
	"./count/count-1.mp3": 380,
	"./count/count-10.mp3": 381,
	"./count/count-2.mp3": 382,
	"./count/count-3.mp3": 383,
	"./count/count-4.mp3": 384,
	"./count/count-5.mp3": 385,
	"./count/count-6.mp3": 386,
	"./count/count-7.mp3": 387,
	"./count/count-8.mp3": 388,
	"./count/count-9.mp3": 389,
	"./count/good-luck.mp3": 390,
	"./countdown.mp3": 123,
	"./drawStop.mp3": 124,
	"./drawing_lo5d.mp3": 644,
	"./goodluck.mp3": 125,
	"./lotto12/l12_voice_eight_v2.mp3": 645,
	"./lotto12/l12_voice_eleven_v2.mp3": 646,
	"./lotto12/l12_voice_five_v2.mp3": 647,
	"./lotto12/l12_voice_four_v2.mp3": 648,
	"./lotto12/l12_voice_nine_v2.mp3": 649,
	"./lotto12/l12_voice_one_v2.mp3": 650,
	"./lotto12/l12_voice_seven_v2.mp3": 651,
	"./lotto12/l12_voice_six_v2.mp3": 652,
	"./lotto12/l12_voice_ten_v2.mp3": 653,
	"./lotto12/l12_voice_three_v2.mp3": 654,
	"./lotto12/l12_voice_twelve_v2.mp3": 655,
	"./lotto12/l12_voice_two_v2.mp3": 656,
	"./lotto12v2/countdownNew.mp3": 657,
	"./lotto12v2/drawBgm.mp3": 658,
	"./lotto12v2/result.mp3": 659,
	"./lotto5_win.mp3": 76,
	"./lotto90/beat_sound_short.mp3": 126,
	"./lotto90/bling_sound.mp3": 212,
	"./lotto90/dying_sound.mp3": 127,
	"./lotto90/result_sound.mp3": 213,
	"./numbers/ball_1_0.mp3": 660,
	"./numbers/ball_1_1.mp3": 661,
	"./numbers/ball_1_2.mp3": 662,
	"./numbers/ball_1_3.mp3": 663,
	"./numbers/ball_1_4.mp3": 664,
	"./numbers/ball_1_5.mp3": 665,
	"./numbers/ball_1_6.mp3": 666,
	"./numbers/ball_1_7.mp3": 667,
	"./numbers/ball_1_8.mp3": 668,
	"./numbers/ball_1_9.mp3": 669,
	"./numbers/ball_2_0.mp3": 670,
	"./numbers/ball_2_1.mp3": 671,
	"./numbers/ball_2_2.mp3": 672,
	"./numbers/ball_2_3.mp3": 673,
	"./numbers/ball_2_4.mp3": 674,
	"./numbers/ball_2_5.mp3": 675,
	"./numbers/ball_2_6.mp3": 676,
	"./numbers/ball_2_7.mp3": 677,
	"./numbers/ball_2_8.mp3": 678,
	"./numbers/ball_2_9.mp3": 679,
	"./numbers/ball_3_0.mp3": 680,
	"./numbers/ball_3_1.mp3": 681,
	"./numbers/ball_3_2.mp3": 682,
	"./numbers/ball_3_3.mp3": 683,
	"./numbers/ball_3_4.mp3": 684,
	"./numbers/ball_3_5.mp3": 685,
	"./numbers/ball_3_6.mp3": 686,
	"./numbers/ball_3_7.mp3": 687,
	"./numbers/ball_3_8.mp3": 688,
	"./numbers/ball_3_9.mp3": 689,
	"./numbers/ball_4_0.mp3": 690,
	"./numbers/ball_4_1.mp3": 691,
	"./numbers/ball_4_2.mp3": 692,
	"./numbers/ball_4_3.mp3": 693,
	"./numbers/ball_4_4.mp3": 694,
	"./numbers/ball_4_5.mp3": 695,
	"./numbers/ball_4_6.mp3": 696,
	"./numbers/ball_4_7.mp3": 697,
	"./numbers/ball_4_8.mp3": 698,
	"./numbers/ball_4_9.mp3": 699,
	"./numbers/ball_5_0.mp3": 700,
	"./numbers/ball_5_1.mp3": 701,
	"./numbers/ball_5_2.mp3": 702,
	"./numbers/ball_5_3.mp3": 703,
	"./numbers/ball_5_4.mp3": 704,
	"./numbers/ball_5_5.mp3": 705,
	"./numbers/ball_5_6.mp3": 706,
	"./numbers/ball_5_7.mp3": 707,
	"./numbers/ball_5_8.mp3": 708,
	"./numbers/ball_5_9.mp3": 709,
	"./posts/0.mp3": 710,
	"./posts/1.mp3": 711,
	"./posts/2.mp3": 712,
	"./posts/3.mp3": 713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;